import React, { useEffect } from "react";

import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import Header from "components/layout/Header";
import { useTranslation } from "react-i18next";
import { ComparisonTable } from "components/ComparisonTable";
import { blobURL } from "common/StringUtils";

const CompanyReview = () => {
  const companyReview = `${blobURL}/invoice-without-company.jpg`;

  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="network-page">
      <Helmet>
        <title>
          {t(
            "Review of Invoicing Without Business: Freelance Finance, Cool Company and Gigger"
          )}
        </title>
        <meta
          name="description"
          content={t(
            "For you as a freelancer, we now compare Invozio with Frilans Finans, Cool Company and Gigger. This is so that you can quickly get an overview of our different platforms and prices."
          )}
        />
      </Helmet>

      <Header />

      <div className="p-0 self_new negotiate network-page mb-0 nw_add_scc busniness_new">
        <div className="negotiation_wrap new_desgn_insurance inspiration fakt new_margin_header px-0 p-0">
          <Container className="self_new responsive_self">
            <div className="seo_pages">
              <section className="insurns_wrap self-empoyee">
                <div className="container">
                  <div className="row align-items-center p-2">
                    <div className="col-lg-6">
                      <div className="slf_text">
                        <h1 className="security_about text-uppercase mb-0">
                          {t(
                            "Review of Invoicing Without Business: Freelance Finance, Cool Company and Gigger"
                          )}
                        </h1>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="text-right">
                        <img
                          src={companyReview}
                          alt="invoicing-without-company"
                          className="img-fluid"
                          style={{
                            borderRadius: "20px",
                            width: "380px",
                            height: "320px",
                            padding: "12px",
                          }}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="newdesign">
                <div className="container p-0">
                  <div className="without_background">
                    <div className="new_text">
                      <p>
                        {" "}
                        {t(
                          `In today's digital age, where the limits of traditional work is blurred, becomes the possibility to invoicing without own company increasingly attractive for freelancers, consultants and small-scale entrepreneurs. But what does it really mean to invoice without having one own business, and what are the advantages? Let's dive down in this exciting topic.`
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t("What does it mean to invoice without a company?")}
                      </h2>
                      <p>
                        {t(
                          "Invoking without a business means, in short, that an individual or group can perform services and then bill for those services without having to register a traditional business. Instead, a third-party service, often called a self-employment platform or invoicing service, is used, which handles the invoicing and administrative burden."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t("Why choose this model?")}
                      </h2>
                    </div>
                  </div>
                  <div className="with_background">
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">{t("Simplicity")}</h3>
                      <p>
                        {t(
                          "Starting and running your own business can be complex, especially when it comes to bookkeeping, taxes and legal requirements. By invoicing without a company, one can avoid many of these complications."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins"> {t("Flexibility")}</h3>
                      <p>
                        {t(
                          "This model is great for those who may only want to do freelance work sporadically or as a side business, without committing to a more permanent corporate structure."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t("Cost effectiveness")}
                      </h3>
                      <p>
                        {t(
                          "For those who do not have a steady stream of income, fixed costs of running a business, such as bookkeeping services or accountants, can become costly. By using a service like Invozio, you minimize these expenses."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t(
                          "Comparison of Invozio against industry leaders Frilans Finans, Gigger, and Cool Company"
                        )}
                      </h2>
                    </div>

                    <ComparisonTable />
                  </div>
                </div>
              </section>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default CompanyReview;
